/* ══ ONBOARDING TOUR CONFIG ═══════════════════════════════════
 *
 * Two-phase tour:
 *   Phase A — 4 "overview" cards introducing each nav group
 *             (Command / Finance / Operations / More). Each
 *             card's bullets are rendered dynamically from the
 *             modules in that group, filtered by the
 *             workspace's package at render time.
 *   Phase B — 2 "action" cards that get the workspace
 *             operational: add first staff member + invite
 *             first family member. Currency, language, and
 *             primary location are captured in the Welcome
 *             step (step 0), so they aren't repeated here.
 *
 * Overview cards have kind:"overview" — the wizard generates
 * their bullets from registry.modulesInGroup(group), filtered
 * by pkgAllows, and skips the card entirely if zero modules
 * in the group are accessible to the workspace.
 *
 * Action cards have kind:"action" and a spotlightTarget. The
 * wizard auto-advances when the tracked state array's length
 * grows, so the user sees their own action land before the
 * wizard resurfaces for the next step.
 * ════════════════════════════════════════════════════════════ */

export const TOUR_FULL_CARDS = [
  /* ── Phase A: 4 overview cards ─────────────────────────── */
  {
    key: "OverviewCommand",
    kind: "overview",
    group: "COMMAND",
    title: "Command",
    titleAr: "القيادة",
    intro:
      "Your daily control room — surfaces what needs attention, tracks every task end-to-end, and ties it all back to the projects and smart home systems you're running.",
    introAr:
      "غرفة التحكم اليومية — تُظهر ما يستدعي الانتباه، وتتابع كل مهمة حتى الإغلاق، وتربطها بالمشاريع وأنظمة المنزل الذكي.",
  },
  {
    key: "OverviewFinance",
    kind: "overview",
    group: "FINANCE",
    title: "Finance",
    titleAr: "المالية",
    intro:
      "Track every dirham — realised and unrealised income, expenses with approval flow, investment holdings and liabilities, and P&L reports with budgets.",
    introAr:
      "تتبع كل ريال — الدخل المحقق وغير المحقق، المصروفات مع سير الاعتماد، الاستثمارات والالتزامات، وتقارير الدخل مع الميزانيات.",
  },
  {
    key: "OverviewOperations",
    kind: "overview",
    group: "OPERATIONS",
    title: "Operations",
    titleAr: "العمليات",
    intro:
      "The daily run of the estate — household requests, facility issues, fleet, staff, transport, meal planning, and your supplier network.",
    introAr:
      "إدارة المنشأة اليومية — طلبات المنزل، بلاغات المرافق، الأسطول، الموظفون، النقل، تخطيط الوجبات، وشبكة الموردين.",
  },
  {
    key: "OverviewMore",
    kind: "overview",
    group: "PRODUCTIVITY",
    title: "More",
    titleAr: "المزيد",
    intro:
      "Support tools layered across the app — an AI workspace for queries, a document vault, and a unified calendar.",
    introAr:
      "أدوات مساندة تعمل عبر التطبيق — مساحة ذكاء اصطناعي للاستعلامات، خزينة مستندات، وتقويم موحّد.",
  },

  /* ── Phase B: single "get started" info card ────────────────
     Previously two separate action steps (invite user / add staff)
     that tracked state growth and auto-advanced. Product decision:
     consolidate into one informational card that navigates to the
     Directory page (family members + staff live there side by side)
     and closes the wizard — no "report back" checkpoint, no final
     dashboard hand-off. If the user needs help with either, the
     whole Directory panel is right there. */
  {
    key: "FamilyStaff",
    kind: "info",
    view: "WorkspaceSettings",
    settingsTab: "directory",
    title: "Add your family and staff",
    titleAr: "أضِف عائلتك وموظفيك",
    intro:
      "Invite family members who need login access, and add staff records for everyone running the estate — drivers, housekeepers, gardeners, cooks. All from one page.",
    introAr:
      "ادعُ أفراد العائلة الذين يحتاجون للدخول، وسجّل الموظفين الذين يديرون المنشأة — سائقين ومدبّرات وبستانيين وطهاة — من صفحة واحدة.",
    cta: "Take me there",
    ctaAr: "خذني إليها",
  },
];

/* Legacy summary module list — no longer used by the wizard
   (overview cards cover the same ground). Kept exported as an
   empty array in case any downstream import still references
   it. Remove in a follow-up cleanup. */
export const TOUR_SUMMARY_MODULES = [];
